<template>
    <div id="products" class="container">
        <transition-group name="list" class="row py-5" tag="div">
            <div :id="`products-item-${i + 1}`" class="col-md-4" v-for="(item, i) in items" :key="`index-${i}`"><!--v-show="cards[i].show"-->
                <a href="#" class="bk-card" @click.prevent="next(i)">
                    <span class="bk-card-img" :style="{backgroundImage: `url(${item.images.length > 0 ? item.images[0].thumb : ''})`}">
                        <img v-if="item.images.length > 0" :src="_.first(item.images).thumb" class="d-none" @load="cards[i].show = true">
                        <img v-else :src="require(`@/templates/${coreParams.theme_name}/assets/no-preview.jpg`)" @load="cards[i].show = true">
                    </span>
                    <span class="bk-card-body">
                        <span class="bk-card-text mb-1 clearfix">
                            <span class="bk-card-text-truncate">
                                <template v-if="cards[i].limitFrom && cards[i].limitTo">
                                    {{ $tc('photo_box_limit', cards[i].limitTo, {limit_from: cards[i].limitFrom, limit_to: cards[i].limitTo}) }}
                                </template>
                                <template v-else-if="cards[i].limitFrom">
                                    {{ $tc('from_n_photos', cards[i].limitFrom, {amount: cards[i].limitFrom}) }}
                                </template>
                                <template v-else-if="cards[i].limitTo">
                                    {{ $tc('until_n_photos', cards[i].limitTo, {amount: cards[i].limitTo}) }}
                                </template>
                            </span>
                            <small class="float-right">{{ $t(item.variants.length === 1 ? 'piece' : 'from') }}</small>
                        </span>
                        <strong class="bk-card-title mb-0 clearfix">
                            {{ item.name }}
                            <span class="float-right">
                                {{ cards[i].price | currency }}
                            </span>
                        </strong>
                    </span>
                </a>
            </div>
        </transition-group>
    </div>
</template>

<style lang="scss" scoped>
    .list-enter-active, .list-leave-active {
        transition: opacity .5s;
    }
    .list-enter, .list-leave-to {
        opacity: 0;
    }
</style>

<script>
  import orderStep3Default from 'src/mixins/orderStep3DefaultComponent';

  export default {
    mixins: [orderStep3Default],
  };
</script>